/**
 * Общие настройки таблиц кабинета: ширины столбцов приходят в DevExtreme числами,
 * а не строками из разметки.
 *
 * Ставится один раз на старте, а не пропсом по гридам: строковые ширины есть почти
 * в каждой таблице, а забытый пропс в одной из них — тот же дефект, только найденный
 * через полгода. Почему строка ломает изменение ширины — в
 * `coerceNumericColumnWidths`.
 *
 * Режим изменения ширины (`columnResizingMode`) НЕ меняем: `nextColumn` — то, что
 * нужно, сосед забирает ровно столько, сколько отдал взятый столбец. Дефект был не
 * в режиме, а в арифметике, которой скармливали строки.
 *
 * Единственное ограничение: у грида, объявившего свой `customizeColumns`, пропс
 * перекрывает эту настройку — там приведение вызывается вручную первой строкой
 * (`OrdersDataGrid`, `MarketplaceMyPrices`).
 */

import DataGrid from "devextreme/ui/data_grid";
import TreeList from "devextreme/ui/tree_list";
import { coerceNumericColumnWidths } from "./coerceNumericColumnWidths";

export function applyDxGridDefaults(): void {
  DataGrid.defaultOptions({ options: { customizeColumns: coerceNumericColumnWidths } });
  TreeList.defaultOptions({ options: { customizeColumns: coerceNumericColumnWidths } });
}
